export default "__VITE_ASSET__CiXnLEeY__"